import { TextInput, Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ConnectedContentLookup = ({
  searchField,
  dropdownOpen,
  setDropdownOpen,
  setSearch,
  pageContainerName = '',
}) => {
  const onCloseDropdown = (ev) => {
    if (ev.keyCode === 27) {
      setDropdownOpen();
    }
  };

  const onClickDelete = () => {
    setSearch();
  };
  const { t } = useTranslation();

  return (
    <div>
      <TextInput
        field={searchField}
        className={`input-field ${dropdownOpen ? 'active' : ''}`}
        placeholder={t('searchAndSelect')}
        iconLeft="search"
        basic
        autoComplete="off"
        data-testid="select-textinput-connected-content-lookup"
        onFocus={() => {
          setDropdownOpen();
          if (pageContainerName) {
            setTimeout(() => {
              const objDiv = document.querySelector(`.${pageContainerName}`);
              objDiv.scrollTop = objDiv.scrollHeight;
            }, 100);
          }
        }}
        onKeyDown={onCloseDropdown}
        right="search"
      />
      {searchField.value.length ? (
        <button
          type="button"
          onClick={() => onClickDelete()}
          className="button-clear-field button-no-underline"
          data-testid="menu-button-delete"
        >
          <Icon name="close" width="16" className="outline icon-white" />
        </button>
      ) : null}
    </div>
  );
};

export default ConnectedContentLookup;
